var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 245.86 262.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "147.52 163.91 131.13 196.69 0 196.69 98.34 0 131.13 0 49.17 163.91 147.52 163.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "213.08 98.34 229.47 65.56 131.13 65.56 98.34 131.13 81.95 163.91 65.56 196.69 32.78 262.25 65.56 262.25 98.34 196.69 114.74 163.91 131.13 131.13 147.52 98.34 213.08 98.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "213.08 163.91 245.86 98.34 213.08 98.34 180.3 163.91 213.08 163.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "180.3 163.91 163.91 131.13 131.13 131.13 147.52 163.91 163.91 196.69 196.69 262.25 229.47 262.25 196.69 196.69 180.3 163.91"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.926170f965c3ebb25e6abfbac9e4d8a2.svg";
export { ForwardRef as ReactComponent };